
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const DemoBanner = () => {
  const isDemoMode = localStorage.getItem('demoMode') === 'true'
  
  if (!isDemoMode) return null
  
  const exitDemo = () => {
    localStorage.clear()
    window.location.href = '/'
  }
  
  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 text-sm">
        <span className="font-medium flex items-center gap-2">
          🎭 Demo Mode Active - Using Sample Data
        </span>
        
        <div className="flex items-center gap-2">
          <Button
            onClick={exitDemo}
            variant="ghost"
            size="sm"
            className="bg-white/20 hover:bg-white/30 text-white h-7 px-3"
          >
            <X className="w-3 h-3 mr-1" />
            Exit Demo
          </Button>
          
          <Button
            asChild
            size="sm"
            className="bg-white text-orange-600 hover:bg-orange-50 h-7 px-3"
          >
            <Link to="/auth/request-access">
              Request Account
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
